import React, { useState } from "react";
import { Box, IconButton } from "@mui/material";
import Iconify from "../../components/iconify/Iconify";

const ItemImagesView = () => {
  // Sample images for demo
  const [images, setImages] = useState([
    { id: 1, url: "https://picsum.photos/200?random=1" },
    { id: 2, url: "https://picsum.photos/200?random=2" },
    { id: 3, url: "https://picsum.photos/200?random=3" },
  ]);

  const handleDelete = (id) => {
    setImages((prev) => prev.filter((img) => img.id !== id));
  };

  return (
    <Box className="item-images">
      <ul
        style={{
          display: "flex",
          flexWrap: "wrap",
          gap: "12px",
          padding: 0,
          margin: 0,
        }}
      >
        {images.map((img) => (
          <li
            key={img.id}
            style={{
              position: "relative",
              listStyle: "none",
              width: 80,
              height: 80,
              borderRadius: 8,
              overflow: "hidden",
              border: "1px solid #e0e0e0",
            }}
          >
            <img
              src={img.url}
              alt="preview"
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
                borderRadius: 8,
              }}
            />
            <IconButton
              size="small"
              onClick={() => handleDelete(img.id)}
              sx={{
                position: "absolute",
                top: 4,
                right: 4,
                bgcolor: "rgba(0,0,0,0.5)",
                color: "#fff",
                "&:hover": { bgcolor: "rgba(0,0,0,0.7)" },
              }}
            >
              <Iconify icon="eva:trash-2-outline" width={16} />
            </IconButton>
          </li>
        ))}
      </ul>
    </Box>
  );
};

export default ItemImagesView;
